import { Controller } from "@hotwired/stimulus"

// Renders a Cloudflare Turnstile widget. api.js only scans the page for widgets
// once, when it first loads, so widgets that arrive with a Turbo visit would
// stay empty. TurnstileHelper loads api.js in explicit mode and this controller
// renders each widget instead. Widgets connected before api.js finishes loading
// render when its onload callback fires.
//
// In development and test the gem's mock script defines no window.turnstile,
// and its mock widget carries its own hidden response field, so this no-ops.
window.onTurnstileLoad = () => document.dispatchEvent(new Event("turnstile:load"))

export default class extends Controller {
    initialize() {
        this.render = this.render.bind(this)
        this.remove = this.remove.bind(this)
    }

    connect() {
        document.addEventListener("turnstile:load", this.render)
        // Remove the widget before Turbo snapshots the page, so a restored
        // snapshot holds an empty container that renders a fresh widget
        document.addEventListener("turbo:before-cache", this.remove)
        // Morph refreshes can skip caching and keep this controller connected.
        // Tear down before rendering, then recreate the widget in the live DOM.
        document.addEventListener("turbo:before-render", this.remove)
        document.addEventListener("turbo:render", this.render)
        this.render()
    }

    disconnect() {
        document.removeEventListener("turnstile:load", this.render)
        document.removeEventListener("turbo:before-cache", this.remove)
        document.removeEventListener("turbo:before-render", this.remove)
        document.removeEventListener("turbo:render", this.render)
        this.remove()
    }

    render() {
        if (!this.element.isConnected || !window.turnstile || this.widgetId !== undefined) return

        this.widgetId = window.turnstile.render(this.element)
    }

    remove() {
        if (this.widgetId === undefined) return

        window.turnstile.remove(this.widgetId)
        this.widgetId = undefined
    }
}
